module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_anatomy_physiology_banner_2019-186e71a691683ce17afd94ab69f202d5.png";